export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/enums/CartItemType.ts